import { getFontSize } from '../../constants/fontSizes';

export const sectionTitleStyles = {
  title: {
    fontFamily: 'Lato',
    fontWeight: 600,
    fontSize: getFontSize(26),
    lineHeight: '34px',
    letterSpacing: '-1%',
    color: '#1F1F1F',
  },
};

